module.exports = __webpack_public_path__ + "static/media/nutseed.5b9cc727.png";